/*
 * @Author: stevensh 
 * @Date: 2020-02-28 17:37:17 
 * @Last Modified by: stevensh
 * @Last Modified time: 2020-02-28 18:24:04
 */

import Route from "./route";
export default Route;